<template>
    <div class="loginfo-container">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
            <el-form :inline="true" :model="filters">
                <el-form-item label="关键字">
                    <el-input size="small" v-model="filters.search" placeholder="姓名，手机号关键字"></el-input>
                </el-form-item>
                <el-form-item>
                    <dateOptionSelector :options="dateOptions" v-model="filters.dateTime" :multiple="true" />
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" v-on:click="queryPageList">查询</el-button>
                    <el-button size="small" type="warning" v-on:click="handleExport">导出</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <!--列表-->
        <el-table stripe border size="mini" :data="tableData" highlight-current-row expand-on-click-node="false"
            style="width: 100%">
            <el-table-column fixed="left" prop="MemberTraining.TraningType" label="计划" width="120" sortable>
                <template slot-scope="scope">
                    <el-tag type="primary">{{ format.dateFormat(scope.row.MemberTraining.ScheduleBeginDate) }}</el-tag>
                    <el-tag type="danger">{{ format.dateFormat(scope.row.MemberTraining.ScheduleEndDate) }}</el-tag>

                </template>
            </el-table-column>
            <el-table-column fixed="left" prop="Member" label="姓名" width="120" sortable> <template slot-scope="scope">
                    <div class="link" v-if="scope.row.MemberTraining.Member">
                        {{ scope.row.MemberTraining.Member.RealName }} <el-tag type="primary">{{
                            scope.row.MemberTraining.Member.Mobile }}</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column fixed="left" prop="Date" label="计划日期/项目" width="120" sortable>
                <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.Date) }}
                    <el-tag type="primary">{{
                        scope.row.Name }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="ResponseDate" label="反馈时间" sortable>
                <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.ResponseDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="CompleteLevel" label="完成情况" sortable>
                <template slot-scope="scope">
                 {{scope.row.CompleteDesc}}
                </template>
            </el-table-column>
            <el-table-column prop="PainNames" label="是否出现疼痛或不适？" sortable>
                <template slot-scope="scope">
                    <span v-if="scope.row.Pains">是 </span><span v-else>否</span>
                    {{scope.row.PainNames}}  
                </template>
            </el-table-column>
            <el-table-column prop="WeakOrLostControlDesc" label="是否出现踝关节“打软”或失控感？" sortable>
                <template slot-scope="scope">
                    <span v-if="scope.row.WeakOrLostControl">是 </span><span v-else>否</span>
                    <span v-if="scope.row.WeakOrLostControlDesc"> {{scope.row.WeakOrLostControlDesc}}</span>   
                </template>
            </el-table-column>
            <el-table-column prop="SituationDesc" label="是否出现以下情况？" sortable>
                <template slot-scope="scope">
                    <el-tag type="primary" v-if="scope.row.Situation">{{scope.row.Situation}}</el-tag>
                    <span v-if="scope.row.SituationDesc">{{ scope.row.SituationDesc }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="ProcessDesc" label="本次训练如何处理？" sortable>
                <template slot-scope="scope">
                    {{scope.row.ProcessDesc}}   
                </template>
            </el-table-column>
            <el-table-column prop="NeedHelpDesc" label="是否需要调整或讲解下次训练动作" sortable>
                <template slot-scope="scope">
                    <span v-if="scope.row.NeedHelp">是 </span>
                    <span v-else>否</span>
                    <span v-if="scope.row.NeedHelpDesc"> {{scope.row.NeedHelpDesc}} </span>   
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" :current-page.sync="pageIndex"></el-pagination>
        </div>
    </div>
</template>
<script>
import { GetTraningList, ExportTraningList } from "@/api/traning/traning";
import dateOptionSelector from "@/components/dateOptionSelector";
export default {
    components: {
        dateOptionSelector,
    },
    data() {
        return {
            filters: {
                search: "",
                traningType: "FootAnkle",
                dateTime: {
                    dateType: "date",
                    date: [],
                },
            },
            dateOptions: [
                { value: "date", name: '计划日期' },
                { value: "response", name: '反馈时间' }
            ],
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            pageSizesList: [10, 15, 20, 30, 50],
        };
    },
    methods: {
        getQueryParams() {
            return {
                traningType: this.filters.traningType,
                search: this.filters.search,
                dateType: this.filters.dateTime.dateType,
                beginDate:
                    this.filters.dateTime.date.length > 0
                        ? this.filters.dateTime.date[0]
                        : "",
                endDate:
                    this.filters.dateTime.date.length > 1
                        ? this.filters.dateTime.date[1]
                        : "",
            };
        },
        queryPageList: function () {
            let data = {
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
                ...this.getQueryParams(),
            };
            GetTraningList(data).then((response) => {
                this.listLoading = false;
                if (response) {
                    this.tableData = response.Items;
                    this.total = response.Total || response.Items.length;
                }
            });
        },
        handleExport() {
            this.loadInstance = this.$loading({
                lock: true,
                text: "正在导出...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            ExportTraningList(this.getQueryParams())
                .then((res) => {
                    this.loadInstance.close();
                    if (res) {
                        window.open(this.baseUrl + res);
                    }
                })
                .catch((ex) => {
                    this.msg.errorMsg("导出出错：" + ex);
                    this.loadInstance.close();
                });
        },
        handleSizeChange(val) {
            var pageSize = `${val}`;
            this.pageIndex = 1;
            this.pageSize = parseInt(pageSize);
            this.$nextTick(() => this.queryPageList());
        },
        handleCurrentChange(val) {
            this.pageIndex = `${val}`;
            this.queryPageList();
        },
        handleDelete(row) {
            this.$confirm("确认删除该天计划吗？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let parma = { key: row.Key };
                del(parma).then((res) => {
                    if (res) {
                        this.queryPageList();
                    }
                });
            });
        },
    },
    mounted() {
        this.queryPageList();
    },
};
</script>

<style lang='scss' scoped>
.loginfo-container {
    padding: 10px;
}

/deep/.el-dialog {
    margin-top: 10px !important;
}
</style>
